/** Section / category options per form — same list as the Add Question Section dropdown. */
export const FORM_SECTIONS = {
  gap_assessment: [
    { id: "notice", label: "Notice & Purpose Limitation" },
    { id: "consent", label: "Consent Management" },
    { id: "purpose", label: "Purpose Limitation" },
    { id: "data_minimisation", label: "Data Minimisation" },
    { id: "storage", label: "Storage Limitation" },
    { id: "accuracy", label: "Data Accuracy" },
    { id: "security", label: "Security Safeguards" },
    { id: "rights", label: "Data Principal Rights" },
    { id: "accountability", label: "Accountability & Governance" },
    { id: "breach", label: "Breach Management" },
  ],
  ropa: [
    { id: "org", label: "Organisation Details" },
    { id: "activity", label: "Processing Activity" },
    { id: "legal", label: "Legal Basis" },
    { id: "principals", label: "Data Principals" },
    { id: "personaldata", label: "Personal Data" },
    { id: "lifecycle", label: "Processing Lifecycle" },
    { id: "sharing", label: "Data Sharing" },
    { id: "retention", label: "Retention & Erasure" },
    { id: "security", label: "Security Safeguards" },
    { id: "rights", label: "Rights Handling" },
    { id: "incident", label: "Incident Management" },
    { id: "approval", label: "Approval & Sign-off" },
  ],
  pia: [
    { id: "general", label: "General Info" },
    { id: "dataDetails", label: "Data Details" },
    { id: "dataFlow", label: "Data Flow" },
    { id: "risk", label: "Risk Assessment" },
    { id: "vendorControls", label: "Vendor & Controls" },
    { id: "safeguards", label: "Safeguards & Review" },
  ],
  tprm: [
    { id: "general", label: "General Information" },
    { id: "security", label: "Cybersecurity & Data" },
    { id: "compliance", label: "Compliance & Regulatory" },
    { id: "financial", label: "Financial Stability" },
    { id: "operational", label: "Operational Risk" },
    { id: "legal", label: "Legal" },
    { id: "reputation", label: "Reputation" },
  ],
};
